export default "__VITE_ASSET__BbGCc7UR__"